import { useMemo, useSyncExternalStore, type ReactNode } from 'react';

import { DatesProvider, type DatesProviderSettings } from '@mantine/dates';

import { getActiveFirstDayOfWeek, subscribeActiveFirstDayOfWeek } from '@/shared/week';

import 'dayjs/locale/es';

/**
 * AM-301: the calendars of the console speak Spanish (months, days of the week). Without it Mantine
 * read them in English ("October 2026", "Mo Tu We").
 *
 * AM-361: they start the week on the tenant's own first day ("Primer día de la semana" of Marca y
 * datos), which the session hands over (`activeTenant.firstDayOfWeek`, `setActiveFirstDayOfWeek`).
 * It was fixed on Monday, beside a setting that said otherwise and a "esta semana" of its own. The
 * calendars already open follow a change of the day: the provider listens to it.
 */
export function TenantDatesProvider({ children }: { children: ReactNode }) {
  const firstDayOfWeek = useSyncExternalStore(
    subscribeActiveFirstDayOfWeek,
    getActiveFirstDayOfWeek,
    getActiveFirstDayOfWeek,
  );
  const settings = useMemo<DatesProviderSettings>(
    () => ({ locale: 'es', firstDayOfWeek }),
    [firstDayOfWeek],
  );

  return <DatesProvider settings={settings}>{children}</DatesProvider>;
}
